/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 7/31/19
 * Time: 1:15 PM
 */
import React, {Component} from 'react';
import Cookies from "js-cookie";
import axiosTags from "../../../../axios/axios_tag";
import * as common from "../../../../const/Common/CommonFunc";
import {MDBModal, MDBModalBody, MDBModalHeader} from "mdbreact";
import {Col, Row} from "reactstrap";

import Lbl from "../../../../components/Label/Lbl";
import {Button as SementicBtn, Button, Checkbox, Icon, Input, Form} from "semantic-ui-react";
import * as EmailValidator from "email-validator";
import swal from "sweetalert";
import are_you_sure_icon from "../../../../assets/img/sweet/question.svg";
import * as actionCreator from "../../../../store/Action";
import {connect} from "react-redux";
import DrpDwn from "../../../../components/Dropdown/Dropdown/DrpDwn";
import LabelInput from "../../../../components/Input/Input/TxtLbl";
import $ from "jquery";
import * as DropDownConst from "../../../../store/Reducer/DropDownConst";
import apiConfig from "../../../../axios/axios_api_services";
import IntlTelInput from "react-intl-tel-input";

class App extends Component {
  state = {
    email: "",
    name: "",
    username: "",
    password: "",
    branch_list: [],
    role: "",
    validatePassword: false,
    validEmail: false,
    isPassword: false,
    status: false,
    mobile: '', format_mobile: '', valid_mobile: false,
  };


  handleChange = (name, length) => event => {
    let value = event.target.value;

    if (name === "password") {
      let reg = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\\$%\\^&\\*])(?=.{9,}$)");
      let result = reg.test(value);
      if (result) {
        this.setState({
          validatePassword: true,
          [name]: value
        });
      } else {
        this.setState({
          validatePassword: false,
          [name]: value
        });
      }
    } else if (name === "email") {
      let validateEmail = EmailValidator.validate(value.trim());
      if (validateEmail) {
        this.setState({
          validEmail: true,
          [name]: value
        });
      } else {
        this.setState({
          validEmail: false,
          [name]: value
        });
      }
    } else {
      this.setState({
        [name]: value
      });
    }
  };

  dropDownChange = name => (event, {value}) => {
    this.setState({
      role: value
    })
  };

  modifySystemUser = () => {

    let condition = false;
    let correct = false;
    this.state.name.trim() === '' ? common.notifyMessage("Please enter full name") :
      this.state.username.trim() === "" ? common.notifyMessage("Please enter username") :
        !this.state.validEmail ? common.notifyMessage("Please enter valid email") :
          !this.state.valid_mobile ? common.notifyMessage("Invalid mobile number") :
            this.state.role.length === 0 ? common.notifyMessage("Please enter branches") :
              condition = true;

    if (condition) {
      if (this.state.isPassword) {
        if (!this.state.validatePassword) {
          common.notifyMessage("Password must contain at least 9 characters, including UPPER/LOWERCASE/SPECIAL_CHARACTER and NUMBERS")
        } else {
          correct = true;
        }
      } else {
        correct = true;
      }
    }

    if (correct) {
      swal({
        title: "Are you sure you want to modify the details",
        icon: are_you_sure_icon,
        closeOnClickOutside: false,
        buttons: {
          cancel: 'Cancel',
          dangerMode: {
            text: "Yes",
            value: "action",
            className: "okay-btn"
          }
        },
      }).then((value) => {
        switch (value) {
          case "action":
            this.sendToBackend();
            break;
          default:
            break;
        }
      });
    }

  };

  sendToBackend = () => {
    const {email, name, username, role, password, status, format_mobile} = this.state;
    const obj = {
      "userId": this.props.data.userId,
      "userName": username,
      "password": password,
      "fullName": name,
      "email": email,
      "status": status ? 1 : 0,
      "userRoles": role,
      "corporates": [this.props.usr_obj.corporateId],
      "branches": [],
      "mobile": format_mobile
    };

    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    axiosTags.post(apiConfig.CORPORATE_SYSTEM_USERS, obj, {headers: headers})
      .then(response => {
        if (response.data.success) {
          common.warningAlert("System user successfully updated - (" + username + ")", 0);

          this.props.closeModal();
          this.props.refreshData();
        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.sendToBackend()
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  viewPassword = () => {
    let i = document.getElementById("password-field");
    if (i.type === "password") {
      i.type = "text"
    } else {
      i.type = "password"
    }
  };

  fillData = () => {
    const {data} = this.props;

    if (data !== null) {
      this.setState({
        email: data.email,
        name: data.fullName,
        username: data.userName,
        role: data.userRoles,
        status: data.status === 1,
        validEmail: true,
        mobile: data.mobile ? data.mobile : "",
        format_mobile: data.mobile ? data.mobile : "",
        valid_mobile: data.mobile ? true : false,
      })
    }
  };
  onPhoneNumberChange = (condition, value, object, withdialcode) => {
    value = value.startsWith("00") ? "+" + value.substr(2) : value;
    this.setState({
      valid_mobile: condition,
      format_mobile: withdialcode,
      mobile: value,
    });
  };

  toggle = () => {
  };

  componentDidMount() {
    this.fillData();
    $('input').attr('autocomplete', 'off');
  }

  render() {
    return (
      <Col>
        <MDBModal isOpen={true} toggle={this.toggle} size="xl">
          <MDBModalHeader className={"title"} toggle={this.props.closeModal}>Modify System User</MDBModalHeader>
          <MDBModalBody>
            <Row style={{padding: '10px'}}>
              <Col xs="12" lg={"12"} md={"12"} className={"padd_grap"}>
                <Row>
                  <Col lg={6}>
                    <Form>
                      <Col className={"none-padding"} lg={12}>
                        <Lbl required>Full Name</Lbl>
                        <LabelInput
                          placeholder={"Full Name"}
                          value={this.state.name}
                          onChange={this.handleChange('name')}
                        />
                      </Col>

                      <Col className={"none-padding"} lg={12}>
                        <Lbl required>User Name</Lbl>
                        <LabelInput
                          placeholder={"User Name"}
                          value={this.state.username}
                          onChange={this.handleChange('username')}
                        />
                      </Col>

                      <Col className={"none-padding"} lg={12}>
                        <Lbl required>Email</Lbl>
                        <LabelInput
                          placeholder={"Email"}
                          value={this.state.email}
                          onChange={this.handleChange('email')}
                        />
                      </Col>
                      <Col className={"none-padding"} lg={12}>
                        <Lbl required>Mobile Number</Lbl>
                        <IntlTelInput
                          type={"text"}
                          fieldName={"Mobile Number"}
                          style={{width: '100%', height: '37px'}}
                          value={this.state.mobile}
                          containerClassName="intl-tel-input dashboard-intl"
                          inputClassName="form-control"
                          onPhoneNumberChange={this.onPhoneNumberChange}
                          required={true}
                          preferredCountries={['lk']}
                          defaultCountry={"lk"}
                          nationalMode={false}
                        />
                      </Col>
                    </Form>
                  </Col>

                  <Col lg={6}>
                    <Form>
                      <Col className={"none-padding"} lg={12}>
                        <Lbl required>Choose USER ROLE</Lbl>
                        <DrpDwn
                          placeholder={"USER ROLE"}
                          options={DropDownConst.userRoles}
                          value={this.state.role}
                          onChange={this.dropDownChange('USER_ROLE')}
                        />
                      </Col>
                      <br/>
                      <Checkbox style={{fontWeight: '600', color: 'rgba(72, 72, 72, 0.87)!important'}}
                                checked={this.state.status} onChange={() => this.setState({status: !this.state.status})}
                                toggle
                                label={this.state.status ? 'Active User' : 'Inactive User'}/>
                      <br/>
                      <br/>
                      <Col className={"none-padding"} lg={12}>
                        <Checkbox style={{fontWeight: '600', color: 'rgba(72, 72, 72, 0.87)!important'}}
                                  checked={this.state.isPassword}
                                  onChange={() => this.setState({
                                    isPassword: !this.state.isPassword,
                                    password: "",
                                    validatePassword: false
                                  })} toggle
                                  label='Do you want to change system user password'/>

                        {
                          this.state.isPassword ?
                            <div>
                              <Lbl required>Password</Lbl>
                              <Input id={"password-field"} type={"password"}
                                     onChange={this.handleChange('password')}
                                     value={this.state.password}
                                     style={{width: '100%'}}
                                     icon={<Icon onMouseUp={() => this.viewPassword(false)}
                                                 onMouseDown={() => this.viewPassword(true)} name='eye' circular link/>}
                                     placeholder='Password'/>
                            </div>
                            : null
                        }
                      </Col>

                    </Form>

                    <center>
                      <Col lg={"12"} className={"marginTop"} style={{marginBottom: '5px'}}>
                        <Button className="px-5" onClick={this.modifySystemUser}>Update System User</Button>
                      </Col>
                    </center>

                  </Col>
                </Row>
              </Col>
            </Row>
          </MDBModalBody>
        </MDBModal>
      </Col>
    );
  }
}

const mapStateToProps = (state) => ({
  view_all_corporates: state.viewAllReducer.view_all_corporates,
  corporate_headers: state.viewAllReducer.corporate_headers,
  // usr obj
  usr_obj: state.userReducer.user,
});

const mapDispatchToProps = (dispatch) => {
  return {
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    //user data handler:
    userHandler: (data) => dispatch(actionCreator.userHandler(data))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
